import React from 'react';
import { Button } from '@mui/material';

type PrimaryButtonProps = {
  text: string;
  heightVariant?: 'small' | 'medium';
  disabled?: boolean;
  handleClick?: () => void;
};

const PrimaryButton = ({
  text,
  heightVariant = 'medium',
  disabled = false,
  handleClick,
}: PrimaryButtonProps): React.ReactNode => {
  return (
    <Button
      variant="contained"
      sx={{
        height: heightVariant === 'small' ? '32px' : '36px',
        borderRadius: '20px',
        backgroundColor: '#000',
        textTransform: 'none',
        boxShadow: 'none',
        fontSize: heightVariant === 'small' ? '12px' : '14px',
        '&:hover': {
          background: '#ddd',
          color: '#000',
          boxShadow: 'none',
        },
        '&:disabled': {
          background: '#ddd',
          color: '#888',
          boxShadow: 'none',
        },
      }}
      disabled={disabled}
      onClick={handleClick}
    >
      {text}
    </Button>
  );
};

export default PrimaryButton;
